import { postJsonRequest } from "../../utils/requestHelper";

export const datasetAssetMeteringChanged = file => dispatch => {
  dispatch({ type: "DATASET_ASSET_METERING_CHANGED", payload: file });
};

export const uploadDatasetAssetMeteringStart = (file) => async dispatch => {
  dispatch({ type: 'UPLOAD_DATASET_ASSET_METERING_START' });
  
  if (file) {
    dispatch({ type: 'UPLOAD_DATASET_ASSET_METERING_SUCCESS' });
    dispatch({ type: 'OPEN_SUCCESS', payload: 'Dataset asset metering uploaded !' });
  } else {
    dispatch({ type: 'OPEN_ERROR', payload: 'No dataset asset metering provided' });
  }
}

export const uploadDatasetAssetMetering = async (file) => {
  var formData = new FormData();
  formData.append("files", file);

  let url = process.env.REACT_APP_API_URL + "/api/maintenance/upload-dataset-asset-metering";

  let datasetFileName = await postJsonRequest(url, formData);

  return datasetFileName;
};


// WEBPACK FOOTER //
// ./src/actions/Maintenance/UploadAssetMeteringActions.js